<template>
    <IconOrg class="h-4 w-4 rounded border border-grey-40 object-contain p-0.5"  v-if="!orgInfo || !orgInfo?.logo || isLoadError" />
    <img class="h-4 w-4 rounded border border-grey-40 object-contain" :src="orgInfo?.logo" @error="handleLoadError" v-else />
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import IconOrg from '@/components/icons/IconOrg.vue'
import type { IOrgInfo } from '@/types';

defineProps<{
    orgInfo?: IOrgInfo;
}>();

const isLoadError = ref(false);

const handleLoadError = () => {
    isLoadError.value = true;
}
</script>
